var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 272,
    height: 86,
    viewBox: "0 0 272 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2649",
    "data-name": "Ret\\xE2ngulo 2649",
    width: 42,
    height: 42,
    transform: "translate(143 1654)",
    fill: "#55a695"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Prancheta_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 86
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prancheta_1",
    "data-name": "Prancheta \\u2013 1",
    clipPath: "url(#clip-Prancheta_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2648",
    "data-name": "Ret\\xE2ngulo 2648",
    width: 272,
    height: 86,
    rx: 5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_de_m\\xE1scara_400",
    "data-name": "Grupo de m\\xE1scara 400",
    transform: "translate(-110 -1634)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "apple",
    d: "M37.217,40.039c-1.757,2.624-3.619,5.185-6.455,5.228-2.836.063-3.746-1.672-6.963-1.672-3.238,0-4.233,1.63-6.921,1.736-2.773.106-4.868-2.794-6.646-5.355C6.612,34.748,3.84,25.118,7.565,18.641a10.337,10.337,0,0,1,8.72-5.312c2.709-.042,5.291,1.841,6.963,1.841,1.651,0,4.783-2.265,8.064-1.926a9.829,9.829,0,0,1,7.7,4.191A9.642,9.642,0,0,0,34.466,25.5a9.34,9.34,0,0,0,5.672,8.551,23.394,23.394,0,0,1-2.921,5.99M25.132,6.175A9.622,9.622,0,0,1,31.355,3a9.262,9.262,0,0,1-2.2,6.752,7.727,7.727,0,0,1-6.244,3.005A9.046,9.046,0,0,1,25.132,6.175Z",
    transform: "translate(141.199 1651)",
    fill: "#55a695"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Dispon\\xEDvel_na_App_Store",
    "data-name": "Dispon\\xEDvel na App Store",
    transform: "translate(90 35)",
    fill: "#55a695",
    fontSize: 18,
    fontFamily: "Montserrat-Regular, Montserrat"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Dispon\xEDvel na"), /*#__PURE__*/React.createElement("tspan", {
    fontSize: 24,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 28
  }, "App Store"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app_store.89ec80c9ddc351819792e4cddf096096.svg";
export { ForwardRef as ReactComponent };